// extracted by mini-css-extract-plugin
module.exports = {"image":"ImageLink_image__W_SjE","link":"ImageLink_link__Lfc7y"};